module.exports = __webpack_public_path__ + "media/images/dragDrop__infoIcon@3x-a2dbd92a2790382f8ad4204fd0dcdc02.png";